<template>
  <div class="product-wrapper" v-if="product && product.skuId">
    <p class="sku-name">{{ spotInfo.spotName + product.skuName }}</p>
    <selectTripDate
      class="calendar-wrapper"
      :availDatePrice="availDatePrice"
      @useTripDate="useTripDate"
    />
    <div class="product-info">
      <div class="ticket-info">
        <p class="ticket">{{ ticket }}</p>
        <p class="price" v-if="price">
          &yen;<span>{{ allPrice }}</span>
        </p>
        <slot />
      </div>
      <p class="fit" v-if="product.applicability">
        <span>{{ product.applicability }}</span>
        <img
          src="https://hzwimspic-1251601690.image.myqcloud.com/02d18f2a-3384-42e0-8888-26d9e0f31508"
          @click="
            () => {
              showFit = true
            }
          "
        />
      </p>
      <div class="tag-warper">
        <div
          v-for="(tag, tagIndex) in tags"
          :key="tagIndex"
          class="ticket-item"
        >
          <span class="tag">{{ tag }}</span>
        </div>
        <div v-if="isIdCard" class="ticket-item">
          <span class="tag" :style="{ color: '#ffa454' }">需要携带身份证</span>
        </div>
        <div class="ticket-item">
          <span
            class="tag"
            :style="{ color: '#666' }"
            @click="
              () => {
                showNotice = true
              }
            "
          >
            购买须知
          </span>
        </div>
      </div>
      <p class="validity">{{ product.termOfValidity }}</p>
      <van-popup
        v-model="showFit"
        round
        position="bottom"
        closeable
        :style="{ height: '50%' }"
      >
        <TicketFit
          :applyPeople="ticket"
          :applicability="product.applicability"
        />
      </van-popup>
      <van-popup
        v-model="showNotice"
        round
        position="bottom"
        closeable
        :style="{ height: '85%' }"
      >
        <BuyNoticePopup :noticeInfo="noticeInfo" :skuInfo="product" />
      </van-popup>
    </div>
  </div>
</template>

<script>
import selectTripDate from '../trip-date/selectTripDate.vue'
import TicketFit from './notice/third/TicketFitPopup.vue'
import BuyNoticePopup from './notice/third/TicketBuyNoticePopup.vue'
import { Popup } from 'vant'
import { queryBookingNotes } from './notice/service'
const TicketType = new Map([
  [0, ''],
  [1, '儿童'],
  [2, '老人'],
  [3, '男人'],
  [4, '女人'],
  [5, '其他'],
  [6, '学生'],
  [7, '成人'],
  [8, '优待'],
  [9, '亲子家庭']
])
export default {
  props: {
    product: {
      type: Object,
      default() {
        return {}
      }
    },
    pkgs: {
      type: Number,
      default: 1
    },
    spotInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    availDatePrice: {
      type: Array,
      default: () => {
        return []
      }
    },
    isIdCard: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      price: 0,
      showFit: false,
      showNotice: false,
      noticeInfo: {}
    }
  },
  async mounted() {
    const result = await queryBookingNotes(this.product.skuId)
    this.noticeInfo = result
  },
  computed: {
    ticket() {
      const applyPeople = +(this.product.applyPeople || '7')
      return `${TicketType.get(applyPeople)}票`
    },
    tags() {
      const tag = []
      if (+this.product.isScheduler === 0) {
        tag.push('随买随用')
      } else {
        tag.push('需预约')
      }
      if (this.product.quickEnter) {
        tag.push('无需取票')
      } else {
        tag.push('需取票')
      }
      if (this.product.isAnyTimeRefund === 1) {
        tag.push('随时退')
      } else if (this.product.isAnyTimeRefund === 2) {
        tag.push('条件退')
      } else if (this.product.isAnyTimeRefund === 0) {
        tag.push('不可退')
      }
      if (this.product.isExpiredRefund === 1) {
        tag.push('过期退')
      }
      return tag
    },
    allPrice() {
      return parseFloat((this.price * this.pkgs).toFixed(2))
    }
  },
  components: {
    selectTripDate,
    TicketFit,
    [Popup.name]: Popup,
    BuyNoticePopup
  },
  methods: {
    useTripDate(data) {
      const selectPrice =
        data.customerPrice != null ? data.customerPrice : data.price
      if (selectPrice) this.price = selectPrice / 100
      this.$emit('useTripDate', data)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
/deep/.van-popup__close-icon {
  color: #666;
  font-size: rem(40px);
}
.product-wrapper {
  margin-bottom: rem(20px);
  border-radius: rem(16px);
  overflow: hidden;
  padding: 0 0 rem(44px);
  background-color: #fff;
  .sku-name {
    color: #121212;
    font-weight: 500;
    font-size: rem(36px);
    padding: rem(32px) 0;
    margin: 0 rem(24px);
    border-bottom: rem(1px) solid #eee;
  }
  .calendar-wrapper {
    margin: 0 rem(24px);
  }
  .product-info {
    margin: 0 rem(24px);
    .ticket-info {
      margin-top: rem(18px);
      display: flex;
      align-items: center;
      .ticket {
        color: #121212;
        flex: 1;
        width: 0;
        @include ellicpsis;
        font-weight: 500;
        font-size: rem(30px);
      }
      .price {
        color: #ff5900ff;
        font-size: rem(24px);
        span {
          font-weight: 500;
          margin-right: rem(20px);
          font-size: rem(36px);
          line-height: rem(50px);
        }
      }
    }
    .fit {
      margin-top: rem(12px);
      display: flex;
      align-items: center;

      span {
        @include ellicpsis;
        max-width: rem(640px);
        font-size: rem(22px);
        color: #666666;
      }
      img {
        margin-left: rem(6px);
        width: rem(22px);
        height: rem(22px);
      }
    }
    .tag-warper {
      display: flex;
      flex-wrap: wrap;
      margin-top: rem(12px);

      .ticket-item {
        white-space: nowrap;
        display: inline-flex;
        align-items: center;
        &:not(:last-child)::after {
          content: '';
          display: inline-block;
          margin: 0 rem(10px);
          background-color: #666666;
          width: rem(1px);
          height: rem(24px);
        }

        &:last-child::after {
          content: '';
          display: inline-block;
          width: rem(20px);
          height: rem(20px);
          background: url(https://hzwimspic-1251601690.image.myqcloud.com/c55d1fb0-addf-4b9f-8acf-eba01fd8b720)
            no-repeat;
          background-size: 100%;
        }

        .tag {
          font-size: rem(24px);
          color: #348be6ff;
          line-height: rem(36px);
        }
      }
    }
    .validity {
      margin-top: rem(12px);
      color: #666666ff;
      font-size: rem(24px);
    }
  }
}
</style>
